export const DefaultCurrency = 'EUR'
